import { REPLACE_GROCERY_LIST_REQUEST } from "./actionTypes";

export default () => ({
  type: REPLACE_GROCERY_LIST_REQUEST,
  payload: {
  }
});